import React from 'react'

import clsx from 'clsx'

import Avatar from 'components/Avatar'
import Icon from 'components/Icon'
import { RESOURCES_DEFAULT_AVATAR_WIDTH } from 'screens/resources/constants'

import classes from './Authors.module.scss'

/** @type {import('./types').default} */
const Authors = ({ authors, className, ...props }) => {
  const mainAuthor = authors[0]
  const multipleAuthors = authors.length > 1
  const finalSrc = mainAuthor.avatar?.url ? mainAuthor.avatar?.url + RESOURCES_DEFAULT_AVATAR_WIDTH : null

  return (
    <div className={clsx('Authors', classes.root, className)} {...props}>
      {multipleAuthors ? (
        <Avatar className={classes.avatar}>
          <Icon icon={['fas', 'users']} />
        </Avatar>
      ) : (
        <Avatar className={classes.avatar} src={finalSrc}>
          <Icon icon={['fas', 'user']} />
        </Avatar>
      )}
      <div className={classes.authorDetails}>
        {multipleAuthors ? (
          authors.map(({ authorName }) => (
            <span key={authorName} className={classes.authorName} data-testid="author-name">
              {authorName}
            </span>
          ))
        ) : (
          <>
            <span className={classes.authorName} data-testid="author-name">
              {mainAuthor.authorName}
            </span>
            <span className={classes.authorTitle} data-testid="author-title">
              {mainAuthor.authorTitle}
            </span>
          </>
        )}
      </div>
    </div>
  )
}

export default Authors
